import React from "react";
import Avatar from "../../common/avatar/avatar";
import { UserDTO } from "../../store/drone_slice";

interface OwnerInfoProps {
  owner: UserDTO;
  creationYear?: string | undefined;
}

const OwnerInfo: React.FC<OwnerInfoProps> = ({ owner, creationYear }) => {
  const ownerName = `${owner.firstName} ${owner.lastName}`;
  
  return (
    <div className="bg-gray-800 text-white p-4 rounded-lg">
      <h3 className="text-xl font-semibold mb-2">About the owner</h3>
      <div className="flex items-center">
        <Avatar />
        <div className="ml-3">
          <p className="font-semibold">{ownerName}</p>
          {creationYear && (
            <p className="text-sm">Member since {creationYear}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OwnerInfo;
